<template>
  <component :is="svgComponent" :class="className" v-if="!useImgNotSvg" />
  <img :class="className" :src="`/images/${name}.svg`" v-else/>
</template>

<script>
import IconComponents from './icons/index.js'

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    useImgNotSvg: Boolean
  },

  components: {
    ...IconComponents
  },

  computed: {
    className () {
      return ['icon', `icon-${this.name}`]
    },
    svgComponent () {
      return IconComponents[`ico-${this.name}`]
    }
  }
}
</script>
<style lang="scss">
    .icon {

      &.icon-trash {
        width: 14px;
        height: 16px;
      }

      &.icon-code {
        width: 16px;
        height: 16px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/base/BaseIcon.vue